var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "import_export_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/communication/import_export_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.99L9 3L13 6.99H10V14H8V6.99H5ZM16 10V17.01H19L15 21L11 17.01H14V10H16Z",
    fill: "#fad504"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.6b32bbb9eea669e44dedbd9a5c144d24.svg";
export { ForwardRef as ReactComponent };